import { isExcludedOrganization } from "./organizationScope";

// Follow recorded parent relationships, including organizations with non-dotted IDs.
// An excluded/inactive branch is never traversed.
export function categoryOrganizationOptions(root, descendants, excludedRefs = "") {
  const exclusions = excludedRefs.split(",").filter(Boolean);
  const children = new Map();
  for (const org of descendants) {
    const parent = org.partOfRefId || org.partOf?.reference?.replace(/^Organization\//, "");
    if (!children.has(parent)) children.set(parent, []);
    children.get(parent).push(org);
  }
  const options = [];
  const visited = new Set();
  const queue = root ? [root] : [];
  for (let index = 0; index < queue.length; index++) {
    const org = queue[index];
    if (!org.id || visited.has(org.id)) continue;
    visited.add(org.id);
    if (org.active === false || isExcludedOrganization(org.id, exclusions)) continue;
    options.push({ value: org.id, label: org.name || "Unnamed organization" });
    queue.push(...(children.get(org.id) || []).sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id)));
  }
  return options;
}
